import { render, staticRenderFns } from "./EditVisibilityModal.vue?vue&type=template&id=8ad406a2&lang=pug"
import script from "./EditVisibilityModal.vue?vue&type=script&lang=js"
export * from "./EditVisibilityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports